<template>
  <v-dialog persistent width="520" v-model="active">
    <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
      <v-card-title class="font-weight-bold justify-center ui-module-titlebar">Editar Novedad</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="form.fk_idCatTipoNovedad"
                filled
                rounded
                dense
                color="secondary"
                background-color="primary"
                :items="tiposNovedad"
                item-value="id"
                item-text="title"
                item-color="secondary"
                :rules="required"
              >
                <template v-slot:label>Tipo de novedad <span class="red--text">*</span></template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-menu
                v-model="menuFecha"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaFormatted"
                    filled
                    rounded
                    dense
                    readonly
                    color="secondary"
                    background-color="primary"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    :rules="required"
                  >
                    <template v-slot:label>Fecha <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="form.fecha"
                  locale="es"
                  color="secondary"
                  no-title
                  @input="menuFecha = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="form.descripcion"
                filled
                rounded
                dense
                color="secondary"
                background-color="primary"
                rows="8"
                :rules="required"
              >
                <template v-slot:label>Descripción <span class="red--text">*</span></template>
              </v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center pb-4 ui-module-actions">
        <v-btn text class="error--text mx-8" @click="closeDialog()">Cancelar</v-btn>
        <v-btn
          color="secondary"
          class="primary--text mx-8 ui-module-btn-solid"
          :loading="loading"
          :disabled="!isFormValid || loading"
          @click="save()"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { VUETIFY_DATE_FORMAT } from '@/const'

export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    novedad: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
      menuFecha: false,
      form: {
        fk_idCatTipoNovedad: null,
        fecha: null,
        descripcion: '',
      },
      required: [(v) => !!v || 'Este campo es requerido'],
    }
  },

  computed: {
    ...mapGetters('tipoNovedad', ['getTiposNovedad']),

    tiposNovedad() {
      return this.getTiposNovedad
    },

    fechaFormatted() {
      return this.form.fecha ? moment(this.form.fecha, VUETIFY_DATE_FORMAT).format('DD/MM/YYYY') : ''
    },

    isFormValid() {
      return !!this.form.fk_idCatTipoNovedad && !!this.form.fecha && this.form.descripcion.trim().length > 0
    },
  },

  watch: {
    novedad: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form.fk_idCatTipoNovedad = val.fk_idCatTipoNovedad
          this.form.fecha = val.fecha ? moment(val.fecha, 'YYYY/MM/DD HH:mm').format(VUETIFY_DATE_FORMAT) : null
          this.form.descripcion = val.descripcion || ''
        }
      },
    },
  },

  methods: {
    ...mapActions('novedad', ['updateNovedad']),

    closeDialog() {
      this.loading = false
      this.$emit('close')
    },

    async save() {
      this.loading = true
      try {
        await this.updateNovedad({
          idPersonal: this.novedad.fk_idUsuario,
          idNovedad: this.novedad.id,
          novedad: {
            fk_idCatTipoNovedad: this.form.fk_idCatTipoNovedad,
            fecha: moment(this.form.fecha, VUETIFY_DATE_FORMAT).format('YYYY/MM/DD HH:mm'),
            fk_idUsuario: this.novedad.fk_idUsuario,
            descripcion: this.form.descripcion,
          },
        })
        this.closeDialog()
      } catch {
        // error ya manejado en el store (snackbar)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
